class DogProfileList extends HTMLElement {
  constructor() {
    super();
    this._isOpen = false;
  }

  render() {
    this.petProfiles = JSON.parse(
      localStorage.getItem('petProfiles') || '{}'
    )?.pets;

    if (!this.petProfiles?.length) {
      // Empty state - show the empty state message
      this.buildProfileEl?.classList.remove('hidden');

      // For PDP: show empty state, hide list wrapper
      const pdpListWrapper = document.getElementById('pdp-pet-list-wrapper');
      const pdpEmptyState = document.getElementById('pdp-pet-empty-state');
      if (pdpListWrapper && pdpEmptyState) {
        pdpListWrapper.classList.add('hidden');
        pdpEmptyState.classList.remove('hidden');
      } else {
        // Fallback for non-PDP contexts (modal)
        this.parentElement.classList.add('hidden');
      }

      this.innerHTML = '';
    } else {
      // Has profiles - show the list
      this.buildProfileEl?.classList.add('hidden');
      this.parentElement.classList.remove('hidden');

      // For PDP: hide empty state, show list wrapper
      const pdpListWrapper = document.getElementById('pdp-pet-list-wrapper');
      const pdpEmptyState = document.getElementById('pdp-pet-empty-state');
      if (pdpListWrapper && pdpEmptyState) {
        pdpListWrapper.classList.remove('hidden');
        pdpEmptyState.classList.add('hidden');
      }

      const selectedPetId = localStorage.getItem('selectedPet');
      const DROPDOWN_THRESHOLD = 3;

      if (this.petProfiles.length >= DROPDOWN_THRESHOLD) {
        this.innerHTML = this._renderDropdown(selectedPetId);
      } else {
        this.innerHTML = this._renderList(selectedPetId);
      }
    }
  }

  _renderList(selectedPetId) {
    const showMealPlan = this.hasAttribute('show-meal-plan-link');
    return `
      <div class="flex flex-col gap-2 w-full">
        ${this.petProfiles
          .map(
            (pet) => `
            <button data-dog-id="${pet.id}" class="${pet.id === selectedPetId ? 'active' : ''} justify-between pdp-pet--button">
              <h4 class="m-0 h5 max-md:text-[14px]">${pet.name}</h4>
              <div class="flex gap-2 items-center">
                <a href="javascript:void(0);" data-id="${pet.id}" class="m-0 h5 max-md:text-[14px] underline js-profile-item-edit">Edit Profile</a>
                ${showMealPlan ? `<span class="text-core-forest/30">|</span><a href="javascript:void(0);" data-id="${pet.id}" class="m-0 h5 max-md:text-[14px] underline js-profile-item-meal-plan">View Meal Plan</a>` : ''}
              </div>
            </button>`
          )
          .join('')}
      </div>`;
  }

  _renderDropdown(selectedPetId) {
    const showMealPlan = this.hasAttribute('show-meal-plan-link');
    const selectedPet = this.petProfiles.find((p) => p.id === selectedPetId) || this.petProfiles[0];
    const chevron = `<svg class="pet-dropdown__chevron" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    return `
      <div class="flex flex-col gap-2 w-full" data-pet-dropdown>
        <button type="button" class="active justify-between pdp-pet--button" data-pet-dropdown-trigger>
          <h4 class="m-0 h5 max-md:text-[14px]">${selectedPet.name}</h4>
          <div class="flex gap-2 items-center">
            <a href="javascript:void(0);" data-id="${selectedPet.id}" class="m-0 h5 max-md:text-[14px] underline js-profile-item-edit">Edit Profile</a>
            ${showMealPlan ? `<span class="text-core-forest/30">|</span><a href="javascript:void(0);" data-id="${selectedPet.id}" class="m-0 h5 max-md:text-[14px] underline js-profile-item-meal-plan">View Meal Plan</a>` : ''}
            ${chevron}
          </div>
        </button>
        <div class="pet-dropdown__menu" data-pet-dropdown-menu>
          ${this.petProfiles
            .filter((pet) => pet.id !== selectedPet.id)
            .map(
              (pet) => `
              <button data-dog-id="${pet.id}" class="justify-between pdp-pet--button">
                <h4 class="m-0 h5 max-md:text-[14px]">${pet.name}</h4>
                <div class="flex gap-2 items-center">
                  <a href="javascript:void(0);" data-id="${pet.id}" class="m-0 h5 max-md:text-[14px] underline js-profile-item-edit">Edit Profile</a>
                  ${showMealPlan ? `<span class="text-core-forest/30">|</span><a href="javascript:void(0);" data-id="${pet.id}" class="m-0 h5 max-md:text-[14px] underline js-profile-item-meal-plan">View Meal Plan</a>` : ''}
                </div>
              </button>`
            )
            .join('')}
        </div>
      </div>`;
  }

  _toggleDropdown(forceClose) {
    const menu = this.querySelector('[data-pet-dropdown-menu]');
    const trigger = this.querySelector('[data-pet-dropdown-trigger]');
    if (!menu || !trigger) return;

    if (forceClose || this._isOpen) {
      menu.classList.remove('is-open');
      trigger.classList.remove('is-open');
      this._isOpen = false;
    } else {
      menu.classList.add('is-open');
      trigger.classList.add('is-open');
      this._isOpen = true;
    }
  }

  prepareFormData(id) {
    const modal = document.querySelector('.dog-info-modal');
    const petProfiles = JSON.parse(
      localStorage.getItem('petProfiles') || '{"pets":[]}'
    );
    const selectedPet = petProfiles.pets.find((pet) => pet.id === id);

    if (!modal || !selectedPet) return;

    const modalContentWrapper = modal.closest('[data-modal-content]');
    const formEl = modal.querySelector('form');
    const nameInputEl = formEl.querySelector('input[name="pet-name"]');
    const emailInputEl = formEl.querySelector('input[name="pet-owner-email"]');
    const weightInputEl = formEl.querySelector('input[name="pet-weight"]');
    const bodyTypeInputEl = formEl.querySelector(
      `input[name="body-type"][value="${selectedPet.bodyType}"]`
    );
    const activityLevelInputEl = formEl.querySelector(
      `input[name="activity-level"][value="${selectedPet.activity}"]`
    );
    const ageInputEl = formEl.querySelector('input[name="pet-age"]');
    const breedInputEl = formEl.querySelector('input[name="pet-breed"]');

    formEl.id = `edit-${selectedPet.id}`;
    nameInputEl.value = selectedPet.name;
    // Pre-fill email if exists in profile
    if (emailInputEl && petProfiles.email) {
      emailInputEl.value = petProfiles.email;
    }
    weightInputEl.value = selectedPet.weight;
    weightInputEl.dispatchEvent(new Event('input'));
    if (bodyTypeInputEl) bodyTypeInputEl.checked = true;
    if (activityLevelInputEl) activityLevelInputEl.checked = true;
    ageInputEl.value = selectedPet.age;
    ageInputEl.dispatchEvent(new Event('input'));
    breedInputEl.value = selectedPet.breed;
    breedInputEl.dispatchEvent(new Event('input'));

    modalContentWrapper.scrollTo({ top: 0, behavior: 'instant' });
  }

  attachEvents() {
    this.addEventListener('click', (e) => {
      // Handle dropdown trigger
      if (e.target.closest('[data-pet-dropdown-trigger]')) {
        e.preventDefault();
        this._toggleDropdown();
        return;
      }

      // Handle dropdown option selection
      const dropdownOption = e.target.closest('.pet-dropdown__option');
      if (dropdownOption) {
        const petId = dropdownOption.getAttribute('data-dog-id');
        localStorage.setItem('selectedPet', petId);
        this._toggleDropdown(true);

        const petData = getPetData(petId);
        document.dispatchEvent(
          new CustomEvent('petSelection:selected', { detail: petData })
        );
        return;
      }

      // Handle button clicks for list mode (set selectedPet in localStorage)
      if (e.target.closest('button[data-dog-id]')) {
        const button = e.target.closest('button[data-dog-id]');
        let petId = button.getAttribute('data-dog-id');
        localStorage.setItem('selectedPet', petId);

        // Grab the pet data
        const petData = getPetData(petId);

        let selectedEvent = new CustomEvent('petSelection:selected', {
          detail: petData
        });
        document.dispatchEvent(selectedEvent);
      }

      // Handle edit profile link clicks

      if (e.target.classList.contains('js-profile-item-edit')) {
        const infoModalList = document.getElementById('dogInfoModalList');
        const infoListIsOpen = Boolean(
          infoModalList && infoModalList.classList.contains('modal-open')
        );
        if (infoModalList) {
          infoModalList.classList.remove('modal-open');
        }
        let saveOnly = false;

        if (this.hasAttribute('data-save-only')) {
          saveOnly = true;
        }

        document.dispatchEvent(
          new CustomEvent('openModal', {
            detail: {
              target: 'dogBuilderModal',
              openedFromModal: infoListIsOpen,
              saveOnly
            }
          })
        );

        this.prepareFormData(e.target.dataset.id);
      }

      // Handle view meal plan link clicks
      if (e.target.classList.contains('js-profile-item-meal-plan')) {
        const petId = e.target.dataset.id;
        const petProfiles = JSON.parse(
          localStorage.getItem('petProfiles') || '{"pets":[]}'
        );
        const petData = petProfiles.pets.find((pet) => pet.id === petId);

        if (petData) {
          // Set this pet as the active selection
          localStorage.setItem('selectedPet', petId);

          // Update pet name in modal
          document
            .querySelectorAll('.js-meal-plan-dog')
            .forEach((el) => (el.textContent = petData.name));

          // Open the modal first
          document.dispatchEvent(
            new CustomEvent('openModal', {
              detail: {
                target: 'dogMealPlanModal'
              }
            })
          );

          // Wait for modal to fully open, then trigger pet selection calculations
          // Using requestAnimationFrame to ensure DOM has updated
          requestAnimationFrame(() => {
            setTimeout(() => {
              let selectedEvent = new CustomEvent('petSelection:selected', {
                detail: petData
              });
              document.dispatchEvent(selectedEvent);
            }, 50);
          });
        }
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (this._isOpen && !e.target.closest('[data-pet-dropdown]')) {
        this._toggleDropdown(true);
      }
    });

    document.addEventListener('petSelection:add', () => this.render());
    document.addEventListener('petSelection:edit', () => this.render());
    document.addEventListener('petSelection:delete', () => this.render());
    document.addEventListener('petSelection:selected', () => this.render());
  }

  connectedCallback() {
    this.buildProfileEl = document.querySelector('.build-profile');
    this.render();
    this.attachEvents();
  }
}

if (!customElements.get('dog-profile-list')) {
  customElements.define('dog-profile-list', DogProfileList);
}

function getPets() {
  const storageItem = localStorage.getItem('petProfiles');
  const pets = storageItem ? JSON.parse(storageItem) : null;
  return pets ? pets.pets || [] : [];
}

function getPetData(id) {
  const pets = getPets();
  return pets.find((pet) => pet.id === id) || null;
}
